import type * as React from 'react';
import { patch } from '@Domain/Api';
import documentTemplateUpdated, {
	type DocumentTemplateUpdatedAction,
	type DocumentTemplateUpdatedPayload,
} from '@Application/Documents/Templates/Actions/documentTemplateUpdated';
import documentTemplateUpdateFailed, {
	type DocumentTemplateUpdateFailedAction,
} from '@Application/Documents/Templates/Actions/documentTemplateUpdateFailed';
import type UpdateDocumentTemplate from '@Application/Documents/Templates/Commands/UpdateDocumentTemplate';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = DocumentTemplateUpdatedAction | DocumentTemplateUpdateFailedAction;

export default (command: UpdateDocumentTemplate) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await patch<DocumentTemplateUpdatedPayload>(
				`${parameters.api.host}/api/organizations/${command.organizationId}/document-templates/${command.templateId}`,
				command.toJSON(),
			);

			const action = documentTemplateUpdated(payload, command.organizationId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = documentTemplateUpdateFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
